import React, { useEffect, useState } from 'react';
import apiService from '../services/apiService';
import PaymentsTable from './PaymentsTable';
import FlashMessage from './FlashMessage';

const PaymentsModal = ({ bill, onClose, onRefresh }) => {
  const [payments, setPayments] = useState([]);

  const [refreshKey, setRefreshKey] = useState(0);

  const [loading, setLoading] = useState(true);

  const [flashMessage, setFlashMessage] = useState('');
  const handleFlashMessage = (message) => {
    setFlashMessage(message);
    setTimeout(() => {
      setFlashMessage(''); // Clear the message after a delay
    }, 3000);
  };

  const refreshData = () => {
    setRefreshKey(prevKey => prevKey + 1);
  };

  useEffect(() => {
    const fetchPayments = async () => {
      try {
        const data = await apiService.getBillPayments(bill);
        setPayments(data);
      } catch (error) {
        console.error('Error fetching payments:', error);
      } finally {
        setLoading(false);
      }
    };
    if (bill) fetchPayments();
  }, [bill]);

  const handleAddPayment = async (payment) => {
    // Build payment data
    const paymentData = {
      ...payment,
      source: 'Frontend',
      biller: bill.biller
    };

    try {
      const response = await apiService.postPayment(bill._id, paymentData);
      const result = await response.json();

      if (response.ok) {
        console.log(result)
        handleFlashMessage(result.message);

        // Re-fetch from backend so we have *confirmed* data
        const updatedPayments = await apiService.getBillPayments(bill);
        setPayments(updatedPayments);

        // Trigger parent refresh to update bills table and status badges
        if (onRefresh) {
          onRefresh();
        }

        // Optional: refresh other views
        const table = document.querySelector('.cash_flows-table');
        if (table && typeof table.refreshData === 'function') {
          table.refreshData();
        }

        // Tells PaymentsTable the payment really landed, so it can offer to
        // link it to a subscription.
        return true;
      } else {
        const errorDetail = result.detail || result.response?.detail || 'Something went wrong';
        console.error('API error:', errorDetail);
        handleFlashMessage(`Error: ${errorDetail} `);
        return false;
      }
    } catch (error) {
      console.error('Request failed:', error);
      handleFlashMessage('An error occurred while adding the payment.');
      return false;
    }
  };

  const handleEditPayment = (index) => {
    // TODO: Implement editable row OR modal form for editing
    console.log('Edit payment at index:', index);
  };

  const handleDeletePayment = async (payment) => {
    const paymentToDelete = payment;
    console.log(paymentToDelete);
    if (!paymentToDelete || !paymentToDelete) {
      console.error("Invalid payment data");
      return;
    }

    try {
      const response = await apiService.deletePayment(bill._id, paymentToDelete);
      const result = await response.json();

      if (response.ok) {
        handleFlashMessage(result.message || "Payment deleted");

        // Re-fetch payments to ensure consistency
        const updatedPayments = await apiService.getBillPayments(bill);
        setPayments(updatedPayments);

        // Trigger parent refresh to update bills table and status badges
        if (onRefresh) {
          onRefresh();
        }
      } else {
        const errorDetail = result.detail || 'Failed to delete payment';
        console.error(errorDetail);
        handleFlashMessage(`Error: ${errorDetail} `);
      }
    } catch (err) {
      console.error('Error deleting payment:', err);
      handleFlashMessage('An error occurred while deleting the payment.');
    }
  };

  return (
    <div style={styles.modalBackdrop}>
      <div style={styles.modalContent}>
        <h3 style={styles.modalHeader}>Payments for Biller {bill.biller}</h3>
        {flashMessage && <FlashMessage message={flashMessage} />}

        {loading ? <p>Loading...</p> :
          <PaymentsTable
            bill={bill}
            payments={payments}
            onAdd={handleAddPayment}
            onEdit={handleEditPayment}
            onDelete={handleDeletePayment}
            fixedValues={{
              "Source": 'Frontend',
              "Biller": bill.biller
            }}
            refreshData={refreshData}
          />
        }
        <button onClick={onClose} style={{ marginTop: '1rem' }}>Close</button>
      </div>
    </div>
  );
};

const styles = {
  modalBackdrop: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(0,0,0,0.7)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 10000, // Higher than sidebar (9999)
  },
  modalContent: {
    backgroundColor: 'black',
    color: 'white',
    padding: '2rem',
    borderRadius: '8px',
    width: 'auto',
    maxWidth: '95vw',
    height: 'auto',
    maxHeight: '95vh',
    overflowY: 'auto',
    overflowX: 'auto',
  },
  modalHeader: {
    wordWrap: 'break-word',
    overflowWrap: 'break-word',
    hyphens: 'auto',
    marginBottom: '1rem',
    maxWidth: '100%'
  }
};

export default PaymentsModal;
